import { WhatsappVariableDefinition } from "@jugl-web/domain-resources/integrations/types/WhatsappVariableDefinition";
import { decodeHTMLEntities } from "@jugl-web/utils/utils/decodeHTMLEntities";
import { WhatsappBody } from "../types";

/**
 * Converts a raw body string to a WhatsappBody.
 * @param rawBody The raw body string to convert.
 * @returns The WhatsappBody.
 * @example
 * rawBodyToWhatsappBody("Hello, *{{Customer Name}}*!"); // { body: "Hello, *{{1}}*!", variables: ["Customer Name"] }
 */
export const rawBodyToWhatsappBody = (
  rawBody: string,
  supportedVariables: WhatsappVariableDefinition[]
): WhatsappBody => {
  let body = decodeHTMLEntities(rawBody);
  const variables: string[] = [];

  const variableMap = new Map<string, WhatsappVariableDefinition>();
  supportedVariables.forEach((variable) => {
    variableMap.set(variable.label, variable);
  });

  const regex = /\{\{([^}]+)\}\}/g;
  const matches: { variableLabel: string; start: number; end: number }[] = [];
  let match = regex.exec(body);

  while (match !== null) {
    const variableLabel = match[1];
    if (variableMap.has(variableLabel)) {
      matches.push({
        variableLabel,
        start: match.index,
        end: match.index + match[0].length,
      });
    }
    match = regex.exec(body);
  }

  matches.reverse().forEach((matchItem, index) => {
    const variable = variableMap.get(matchItem.variableLabel);
    if (variable) {
      const variableNumber = matches.length - index;
      body = `${body.substring(
        0,
        matchItem.start
      )}{{${variableNumber}}}${body.substring(matchItem.end)}`;
      variables.unshift(variable.id);
    }
  });

  return {
    body,
    variables,
  };
};
